<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Claim', apiMethod: 'Claims', form: () => import('../forms/ClaimForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Role Claim', apiMethod: 'RoleClaims', parentForeignKey: 'claimId', form: () => import('../forms/RoleClaimForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Roles', value: 'claimId', isCard: true, table: () => import('../tables/RoleClaimsTable') },
                ],
                mainForm: () => import('../forms/ClaimForm'),
                claimName: 'Claims',
                apiMethod: 'Claims',
            }
        }
    };
</script>
